module.exports = __webpack_public_path__ + "img/61.236be723.jpg";